<div class="search-modal">
  <div class="search-modal-container">
    <div class="search-modal-form  js-modal__wrapper--form" id="searchHeader" >
      <div class="search-location js-search_location">
        <div class="search-location__input-wrapper">
          <input  [formControl]="$any(searchForm.get('query'))"
                  type="text"
                  class="input-text search-location__input js-location_input js-location_input-modal"
                  placeholder="Название жилого комплекса">
          <svg width="20" height="21" viewBox="0 0 24 25" xmlns="http://www.w3.org/2000/svg"><g stroke="#8F8F8F" stroke-width="2" fill="none" fill-rule="evenodd"><circle cx="9.603" cy="10.556" r="8.603"></circle><path d="M15.976 16.93L23.048 24" stroke-linecap="round" stroke-linejoin="round"></path></g></svg>
          <div class="location-clear js-clear-input"></div>
        </div>
        <ng-container *ngIf="hasSearchTips(searchResult?.data)">
          <div class="search-location__tips js-location_tips">
            <ng-container *ngFor="let item of searchResult?.data">
              <a href="{{ getSearchTipUrl(item.value) }}">
                <div id="{{item.type}}" class="location-tips">
                  <div class="location-tips__title">{{item.meta.text}}</div>
                  <div class="location-tips__subtitle">{{item.meta.description}}</div>
                </div>`
              </a>
            </ng-container>
          </div>
        </ng-container>
      </div>
    </div>
  </div>
</div>
